<template>
  <WdsStack direction-column class="tw-gap-7">
    <DashboardMetricsNumbers />

    <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-7">
      <div class="tw-flex tw-flex-col tw-gap-7 tw-w-full md:tw-w-1/2">
        <UpcomingActions />
        <SourcingActivity />
      </div>

      <div class="tw-flex tw-flex-col tw-gap-7 tw-w-full md:tw-w-1/2">
        <Workforce />
        <ProjectTracker />
      </div>
    </div>
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsStack } from '@worksome/wds-components'
import DashboardMetricsNumbers from '@/components/Dashboard/Metrics/DashboardMetricsNumbers.vue'
import UpcomingActions from '@/components/Dashboard/Widgets/UpcomingActions/UpcomingActions.vue'
import SourcingActivity from '@/components/Dashboard/Widgets/SourcingActivity.vue'
import Workforce from '@/components/Dashboard/Widgets/Workforce.vue'
import ProjectTracker from '@/components/Dashboard/Widgets/ProjectTracker.vue'
</script>

